/**
 * Splash-Screen JavaScript API für luzula-lib Apps.
 *
 * Einbinden in angular.json → scripts:
 *   { "input": "node_modules/@luzula/luzula-lib/assets/scripts/splash-screen.js", "inject": true }
 *
 * Oder als Inline-Script in index.html einbetten.
 *
 * Stellt globale Funktionen bereit:
 *   - window.updateSplashStatus(text) — Statustext aktualisieren
 *   - window.hideSplashScreen() — Splash Screen ausblenden (mit Fade-Animation)
 *
 * Der Angular SplashScreenService nutzt diese Funktionen intern.
 */

// Statustext im Splash Screen aktualisieren
window.updateSplashStatus = function (text) {
	var statusEl = document.getElementById('splash-status');
	if (statusEl) {
		statusEl.textContent = text;
	}
};

// Splash Screen mit Fade-Animation ausblenden
window.hideSplashScreen = function () {
	var splash = document.getElementById('splash-screen');
	if (splash) {
		splash.classList.add('fade-out');
		setTimeout(function () {
			splash.remove();
		}, 500);
	}
};

// Fallback: Splash Screen nach Timeout automatisch entfernen
setTimeout(function () {
	if (document.getElementById('splash-screen')) {
		console.warn('Splash Screen Timeout — wird automatisch entfernt');
		window.hideSplashScreen();
	}
}, 100000);
